import type { HTMLAttributes, ReactNode } from "react";

import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import clsx from "clsx";
import { usePathname } from "next/navigation";

import type { NavigationItem } from "@/src/components/navigation/NavigationItems";

import { AppLink } from "@/src/components/navigation/AppLink";

interface NavigationItemsSocietaireProps extends HTMLAttributes<HTMLOListElement> {
  readonly items: NavigationItem[];
}

export function NavigationItemsSocietaire({
  className,
  items,
}: NavigationItemsSocietaireProps): ReactNode {
  const pathname = usePathname();
  return (
    <NavigationMenu.List
      aria-label="Menu sociétaire"
      className={clsx(
        "font-medium-antialiased text-primary flex flex-col gap-2 tracking-wide",
        className,
      )}
    >
      {items.map(({ href, icon, label }) => (
        <NavigationMenu.Item key={label}>
          <NavigationMenu.Link
            asChild
            className={clsx(
              "block rounded-sm p-1.5 transition-all",
              "before:mr-2 before:inline before:content-[attr(data-before)]",
              "hover:bg-gray-lightest",
              { "bg-gray-lightest": pathname === href },
            )}
            data-before={icon}
          >
            <AppLink href={href}>{label}</AppLink>
          </NavigationMenu.Link>
        </NavigationMenu.Item>
      ))}
    </NavigationMenu.List>
  );
}
